var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.27392 1.28113C4.90992 0.973133 4.90992 0.637133 5.27392 0.273133C5.58192 -0.090867 5.91792 -0.090867 6.28192 0.273133L10.3139 4.38913C10.6219 4.69713 10.6219 5.03313 10.3139 5.39713L6.28192 9.51313C5.91792 9.87713 5.58192 9.87713 5.27392 9.51313C4.93792 9.17713 4.93792 8.82713 5.27392 8.46313L8.54992 4.89313L5.27392 1.28113Z",
    fill: "#292929"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.273922 1.28113C-0.0900779 0.973133 -0.0900779 0.637133 0.273922 0.273133C0.581922 -0.090867 0.917922 -0.090867 1.28192 0.273133L5.31392 4.38913C5.62192 4.69713 5.62192 5.03313 5.31392 5.39713L1.28192 9.51313C0.917922 9.87713 0.581922 9.87713 0.273922 9.51313C-0.062078 9.17713 -0.062078 8.82713 0.273922 8.46313L3.54992 4.89313L0.273922 1.28113Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrow);
export default __webpack_public_path__ + "static/media/DoubleArrow.2dc6016c69d1430992807a1bdb7ede02.svg";
export { ForwardRef as ReactComponent };